export default __webpack_public_path__ + "static/tomates-b4858a005afbde2c4872be8717de1c53.jpg";